import A11yDialog from 'a11y-dialog';

export function EmbeddedMap(container, onShow) {

    mapboxgl.accessToken = 'pk.eyJ1IjoiaTVicmlkZ2VyZXBsYWNlbWVudCIsImEiOiJja3UyaTU5encwcWFtMm5uaWdxcTl0MHkwIn0.HhwR6QLKpLU3G8jWpquk9g';
    window.embeddedMap = new mapboxgl.Map({
        container: container,
        style: 'mapbox://styles/i5bridgereplacement/cku2i7uql324x18oudega4voo/draft',
        center: [-122.6752, 45.6183],
        pitch: 58.1449083309002,
        bearing: -38.40527054142097,
        zoom: 5
    });
    window.embeddedMap.addControl(new mapboxgl.NavigationControl());

    const points = window.mapGeoJson.features.filter((feature) => feature.geometry.type == 'Point');

    window.embeddedMap.on('load', () => {

        const bounds = new mapboxgl.LngLatBounds();

        // Extend the 'LngLatBounds' to include every coordinate in the bounds result.
        for (const feature of points) {
            bounds.extend(feature.geometry.coordinates)
        }

        fitBoundsRotated(bounds);

        window.embeddedMap.addSource('map', {
            type: 'geojson',
            data: window.mapGeoJson
        });
        window.embeddedMap.addLayer({
            id: 'route',
            type: 'line',
            source: 'map',
            paint: {
                'line-color': '#888',
                'line-width': 8
            },
            layout: {
                'line-join': 'round',
                'line-cap': 'round'
            },
            filter: ['==', '$type', 'LineString']
        });

        for (const { geometry, properties } of points) {
            // create a HTML element for each feature
            const el = document.createElement('button');
            el.className = `marker marker--${properties.color}`
            el.title = properties.name
            el.innerText = properties.number
            el.addEventListener('click', function (event) {
                markerOnClick(properties);
			})

            // make a marker for each feature and add to the map
            new mapboxgl.Marker(el)
                .setLngLat(geometry.coordinates)
                .addTo(window.embeddedMap);
        }

    });

    // Copied code from MapBoxGL's Camera#fitBounds method
    // Adding in rotation logic
    function fitBoundsRotated(bounds, eventData){

        var options = {
            padding: {
                top: 0,
                bottom: 0,
                right: 0,
                left: 0
            },
            offset: [0, 0],
            maxZoom:28
        };

        bounds = mapboxgl.LngLatBounds.convert(bounds);

        // we separate the passed padding option into two parts, the part that does not affect the map's center
        // (lateral and vertical padding), and the part that does (paddingOffset). We add the padding offset
        // to the options `offset` object where it can alter the map's center in the subsequent calls to
        // `easeTo` and `flyTo`.
        const paddingOffset = [options.padding.left - options.padding.right, options.padding.top - options.padding.bottom],
            lateralPadding = Math.min(options.padding.right, options.padding.left),
            verticalPadding = Math.min(options.padding.top, options.padding.bottom);
        options.offset = [options.offset[0] + paddingOffset[0], options.offset[1] + paddingOffset[1]];

        options.bearing = options.bearing || window.embeddedMap.getBearing();

        const offset = mapboxgl.Point.convert(options.offset),
            tr = window.embeddedMap.transform,
            nw = tr.project(bounds.getNorthWest()),
            se = tr.project(bounds.getSouthEast()),
            size = se.sub(nw);

        /** START CUSTOM ROTATION HACK **/
        // Now using a "cropped rectangle" rotation method
        // https://stackoverflow.com/questions/33866535/how-to-scale-a-rotated-rectangle-to-always-fit-another-rectangle
        // W = w·|cos φ| + h·|sin φ|
        // H = w·|sin φ| + h·|cos φ|
        const theta = options.bearing * (Math.PI / 180),
            W = size.x * Math.abs(Math.cos(theta)) + size.y * Math.abs(Math.sin(theta)),
            H = size.x * Math.abs(Math.sin(theta)) + size.y * Math.abs(Math.cos(theta)),
            rotatedSize = { x: W, y: H },
            /** END CUSTOM ROTATION HACK **/

            scaleX = (tr.width - lateralPadding * 2 - Math.abs(offset.x) * 2) / rotatedSize.x,
            scaleY = (tr.height - verticalPadding * 2 - Math.abs(offset.y) * 2) / rotatedSize.y;

        if (scaleY < 0 || scaleX < 0) {
            if (typeof console !== "undefined") console.warn('Map cannot fit within canvas with the given bounds, padding, and/or offset.');
            return this;
        }

        options.center = tr.unproject(nw.add(se).div(2));
        options.zoom = Math.min(tr.scaleZoom(tr.scale * Math.min(scaleX, scaleY)), options.maxZoom);


        return options.linear ?
            window.embeddedMap.easeTo(options, eventData) :
            window.embeddedMap.flyTo(options, eventData);
    }
    const markerOnClick = (props) => {
        const ref = `flipModalContent${props.number}`;
        const content = document.getElementById(ref);

        // Create dialog markup
        const dialogEl = document.createElement('div');
        dialogEl.className = 'popup dialog-container mapEmbedDialog';
        dialogEl.id = `markerDialog${props.number}`;
        dialogEl.setAttribute('aria-hidden', 'true');

        const dialogOverlay = document.createElement('div');
        dialogOverlay.className = 'dialog-overlay';
        dialogOverlay.tabIndex = '-1';
        dialogEl.appendChild(dialogOverlay);

        const dialogContent = document.createElement('div');
        dialogContent.className = 'dialog-content';
        dialogContent.setAttribute('role', 'alertdialog');
        dialogContent.setAttribute('aria-labelledby', 'dialogTitle');
        dialogEl.appendChild(dialogContent);

        const dialogDocument = document.createElement('div');
        dialogDocument.setAttribute('role', 'document');
        dialogContent.appendChild(dialogDocument);

        const dialogButton = document.createElement('button');
        dialogButton.setAttribute('aria-label', 'Close this dialog window');
        dialogButton.className = 'dialog-close btn btn--solid-tertiary';
        dialogButton.innerHTML = '&times;';
        dialogButton.dataset.a11yDialogHide = `markerDialog${props.number}`;
        dialogDocument.appendChild(dialogButton);

        const dialogTitle = document.createElement('h1');
        dialogTitle.id = 'dialogTitle';
        dialogTitle.className = 'dialog-title heading heading--secondary';
        dialogTitle.textContent = props.name;
        dialogDocument.appendChild(dialogTitle);

        content.hidden = false;
        dialogDocument.appendChild(content);

        // Append dialog to body
        const documentBody = document.querySelector('body');
        documentBody.appendChild(dialogEl);

        // Create dialog instance
        const dialog = new A11yDialog(dialogEl);
        dialog.on('show', function (dialogEl) {
            documentBody.classList.add('no-scroll')
        })

        dialog.on('hide', function (dialogEl) {
            documentBody.classList.remove('no-scroll')
            content.hidden = true;
            documentBody.appendChild(content);
            documentBody.removeChild(dialogEl);
        })

        //Show the dialog
        dialog.show()
	}

};